// ---------------------------------------------------------------------------
// Inputs (router) — escolhe a view de Inputs conforme a implementacao.
// ---------------------------------------------------------------------------
// O menu lateral expoe um unico item "Inputs" (path ``/inputs``). Aqui
// decidimos se rendermos o V2 (legacy ``InputsV2``) ou o V3 (``InputsV3``)
// com base na feature flag ``inputs_v3`` da implementacao do usuario.
//
// Premissa: cada implementacao usa V2 OU V3 (nao ambos). A flag
// ``inputs_v3`` chega no ``userDetails.features`` (mesmo mecanismo
// usado para gating de menu / rota em routes.js, Sidebar.js, Main.js).
// ---------------------------------------------------------------------------

import React, { useContext } from "react";
import AuthContext from "../../contexts/AuthProvider";
import InputsV2 from "./InputsV2";
import InputsV3 from "./InputsV3";

const Inputs = (props) => {
  const { userDetails } = useContext(AuthContext);
  const hasV3 = (userDetails?.features || []).includes("inputs_v3");
  const Component = hasV3 ? InputsV3 : InputsV2;
  return <Component {...props} />;
};

export default Inputs;
